import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import AddItem from '../../../shared/TechSkills/AddItem';
import Item from '../../../shared/TechSkills/Item';
import DragNDropList from '../../../shared/DragNDropList';
import config from '../../../config';

const IdeOrToolsTab = ({ data, onChange }) => {
  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  useEffect(() => {
    if (!('ideOrTools' in data)) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'ideOrTools',
          value: {
            enable: false,
            heading: 'IDE/TOOLS',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    'ideOrTools' in data && (
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab">{t('ideOrTools.title.label')}</div>
          <div className="col-span-1">
            <Checkbox
              checked={data.ideOrTools.enable}
              onChange={v => onChange('data.ideOrTools.enable', v)}
            />
          </div>
        </div>

        <hr className="my-6" />

        <DragNDropList
          data={data}
          dispatch={dispatch}
          onChange={onChange}
          type="ideOrTools"
        >
          {data.ideOrTools.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.ideOrTools.items.length - 1}
              type='ideOrTools'
              idTab={config.TECH_SKILLS_TABS.ideOrTools}
            />
          ))}          
        </DragNDropList>


        <AddItem heading={data.ideOrTools.heading} dispatch={dispatch} type='ideOrTools' idTab={config.TECH_SKILLS_TABS.ideOrTools} />
      </>
    )
  );
};

export default IdeOrToolsTab;
